<script>
import i18nValidate from '@/i18n/vi/i18nValidate';
export default {
	name: 'msBaseComponent',
	props: {
		readonly: {
			default: false,
			type: Boolean,
		},
		//rule dùng để validate control
		//Created by LTDAT(22.06.2020)
		rules: {
			type: String,
			default: null,
		},
		/**
		 * Tên của control phục vụ việc hiện thị message cho validate
		 * Created by LTDAT(22.06.2020)
		 */
		name: {
			default: null,
			type: String,
		},
	},
	created() {
		const me = this;
	},
	mounted() {
		const me = this;
	},
	data() {
		return {
			errorProvider: {},
		};
	},
	methods: {
		setPlacementTooltip() {
			const me = this;
			let placement = 'bottom';
			let pos = me.$el.getBoundingClientRect(),
				windowWidth =
					window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth;
			if (pos.right > windowWidth - 200) {
				placement = 'bottom-end';
			}
			return placement;
		},
		getErrorProvider() {
			return this.errorProvider;
		},
		/**
		 * Validate component sự kiện validate control
		 * Created by LTDAT(22.06.2020)
		 *  */
		validate(editor) {
			const me = this;

			// Disabled thì không validate
			if (me.disabled) {
				me.errorProvider = {};
				return me.errorProvider;
			}

			// Parse rules
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rules) {
				listRules = me.rules.split('|');
			}

			// Validate theo từng rule
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(
					listRules[i],
					me.internalText || me.value,
					editor
				);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}

			// Set errorProvider
			if (ret) {
				if (i18nValidate.messages[rulesValidate]) {
					me.$set(
						me.errorProvider,
						'message',
						i18nValidate.messages[rulesValidate](me.name ? me.name : me.title)
					);
				}
				me.$set(me.errorProvider, 'isValid', true);
				let placement = me.setPlacementTooltip();
				me.$set(me.errorProvider, 'placementTooltip', placement);
				me.$set(me.errorProvider, 'rules', rulesValidate);
				me.$set(me.errorProvider, 'element', me.$refs.input);
			} else {
				me.errorProvider = {};
			}
			return me.errorProvider;
		},
		validateRule(rule, value, editor, dataSource) {
			const me = this;
			switch (rule) {
				case 'forceSelection':
					return me.validateForceSelection(value, editor, dataSource);
				case 'required':
					return me.validateRequired(value);
				case 'taxCodeOrIdentification':
					return me.validateTaxCodeOrIdentification(value);
				case 'requiredTrim':
					return me.validateRequired(value, true);
				case 'taxCode':
					return me.validateTaxCode(value);
				case 'phoneEmail':
					return me.validatePhoneEmail(value);
				case 'phone':
					return me.validatePhone(value);
				case 'email':
					return me.validateEmail(value);
				case 'password':
					return me.validatePassword(value);
				case 'requiredNumber':
					return me.validateNumberRequired(value);
			}
		},
		//Validate number required
		validateNumberRequired(value) {
			if (value === undefined || value === null || value === 0) {
				return false;
			} else {
				return true;
			}
		},
		//Validate required
		validateRequired(value, isTrim = false) {
			if (isTrim && value) {
				value = value.trim();
			}

			// Validate required
			if (value === undefined || value === null || value === '') {
				return false;
			} else {
				return true;
			}
		},
		//Validate mã số thuế
		validateTaxCode(value) {
			try {
				let oRegex =
					/^[0-9]{12}$|^[0-9]{10}$|^[0-9]{13}$|^[0-9]{10}(\s|-)[0-9]{3}$/;
				if (oRegex.test(value)) {
					let arrcode = [],
						lengthCode = value.length;
					for (let i = 0; i < lengthCode; i++) {
						arrcode.push(value[i]);
					}

					let intTemp =
						31 * parseFloat(arrcode[0]) +
						29 * parseFloat(arrcode[1]) +
						23 * parseFloat(arrcode[2]) +
						19 * parseFloat(arrcode[3]) +
						17 * parseFloat(arrcode[4]) +
						13 * parseFloat(arrcode[5]) +
						7 * parseFloat(arrcode[6]) +
						5 * parseFloat(arrcode[7]) +
						3 * parseFloat(arrcode[8]);
					// Validate mã số thuế 10 chữ số
					if (!(parseFloat(arrcode[9]) === 10 - (intTemp % 11))) {
						return false;
					}
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		validatePhoneEmail(value) {
			try {
				return this.validatePhone(value) || this.validateEmail(value);
			} catch (e) {
				return false;
			}
		},
		validatePhone(value) {
			try {
				// let oRegex = /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
				let oRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
				let result = value;
				if (!oRegex.test(result.trim())) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		validateEmail(value) {
			try {
				let oRegex =
					/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				let result = value;
				if (!oRegex.test(result.trim())) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		validatePassword(value) {
			const me = this;
			let lengthPass = false;
			// Kiểm tra độ dài
			if (value && value.length >= 8) {
				lengthPass = true;
			}

			let textPass = false;
			let upcasePass = false;
			let lowercasePass = false;
			// Kiểm tra chữ hoa và chữ thường
			if (value && /[^A-Z]/g.test(value)) {
				upcasePass = true;
			}

			// Kiểm tra chữ thường
			if (value && /[^a-z]/g.test(value)) {
				lowercasePass = true;
			}

			// Kết luận chữ hoa và chữ thường
			if (upcasePass && lowercasePass) {
				textPass = true;
			}

			// Kiểm tra số
			let numberPass = false;
			if (value && /[^0-9]/g.test(value)) {
				numberPass = true;
			}

			// Set lỗi
			me.$set(me.errorProvider, 'lengthPass', lengthPass);
			me.$set(me.errorProvider, 'textPass', textPass);
			me.$set(me.errorProvider, 'numberPass', numberPass);
			return lengthPass && textPass && numberPass;
		},
		validateForceSelection(value, editor, data) {
			const me = this;
			// Nếu có editor thì mới kiểm tra
			if (editor) {
				let dataSource = data || editor.internalDataSource;
				if (dataSource && dataSource.length > 0) {
					let valueText = value;
					let typeAheadPointer = editor.filterIndexItemByText(
						valueText,
						dataSource
					);
					if (
						typeAheadPointer != null &&
						typeAheadPointer != undefined &&
						typeAheadPointer >= 0
					) {
						return true;
					} else {
						return false;
					}
				}
			}
			return true;
		},
		applyValidate(message) {
			const me = this;
			if (message) {
				me.$set(me.errorProvider, 'message', message);
				me.$set(me.errorProvider, 'isValid', true);
				let placement = me.setPlacementTooltip();
				me.$set(me.errorProvider, 'placementTooltip', placement);
				me.errorProvider.element = me.$refs.input;
			} else {
				me.errorProvider = {};
			}
		},

		/**
		 * Validate kết hợp cho mã số thuế và CCCD chủ hộ (CCCD)
		 * - Nếu có cả hai, validate từng phần
		 * - Nếu chỉ có một, validate phần đó
		 * @param {string} value Giá trị cần kiểm tra, dạng "TaxCode/IdentificationNumber"
		 * @returns {boolean} Kết quả kiểm tra (true: hợp lệ, false: không hợp lệ)
		 */
		validateTaxCodeOrIdentification(value) {
			// Trim giá trị đầu vào
			const val = value.trim();

			// Nếu giá trị trống, coi như hợp lệ
			if (!val) return true;

			// Kiểm tra cả hai định dạng
			return (
				this.validateIdentificationNumber(val) || this.validateTaxCode(val)
			);
		},

		/**
		 * Kiểm tra CCCD chủ hộ có đúng định dạng không
		 * - Phải là dạng số
		 * - Phải có đúng 12 chữ số
		 * @param {string} value Giá trị cần kiểm tra
		 * @returns {boolean} Kết quả kiểm tra (true: hợp lệ, false: không hợp lệ)
		 */
		validateIdentificationNumber(value, isEmptyNoValid = true) {
			try {
				// Xử lý giá trị trống
				if (isEmptyNoValid && !value) {
					return true; // Giá trị trống được xử lý bởi rule 'required' nếu cần
				}

				// Trim giá trị
				if (value) {
					value = value.trim();
				}

				// Biểu thức chính quy kiểm tra chính xác 12 chữ số
				const oRegex = /^[0-9]{12}$/;
				return oRegex.test(value);
			} catch (e) {
				return false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
</style>

